var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateFromGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18.783,
    viewBox: "0 0 24 18.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sort-date-descending",
    d: "M20.283,8.674h-3.13L21.326,4.5,25.5,8.674H22.37V23.283H20.283V8.674M8.8,18.065h3.13v-3.13H8.8v3.13M14.022,6.587H12.978V4.5H10.891V6.587H6.717V4.5H4.63V6.587H3.587A2.08,2.08,0,0,0,1.5,8.674V20.152a2.08,2.08,0,0,0,2.087,2.087H14.022a2.08,2.08,0,0,0,2.087-2.087V8.674a2.08,2.08,0,0,0-2.087-2.087M3.587,20.152v-7.3H14.022v7.3Z",
    transform: "translate(-1.5 -4.5)",
    fill: "#c1c1c1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateFromGray);
export default __webpack_public_path__ + "static/media/date-from-gray.ab498e28ecae8e2d27fc351c4d76272f.svg";
export { ForwardRef as ReactComponent };